export const ONLINE = 1; // Website is online
export const SUBSCRIPTION = 2; // Event subscriptions open
export const EVALUATION = 3; // Event evaluation forms open
export const LIVE_EVENT = 4; // Event evaluation forms open
export const ON_DEMAND_EVENT = 5; // Event evaluation forms open
export const ACTIVE_PLAYER = 6; // Episode player is visible

// MAIL SCHEDULER
export const SCHEDULE_CERTIFICATE_REMINDER = 11;
export const SCHEDULE_CERTIFICATE_DELIVERY = 12;

export const LIVE_REMINDER = 21;
export const LIVE_ONDEMAND_REMINDER = 22;
export const ONDEMAND_REMINDER = 23;
export const VPN_REMINDER = 24;
export const MEET_THE_EXPERTS_REMINDER = 25;